export default theme => ({
    sliderContainer: {
        margin: theme.spacing(0, 0.5),
    },
    slider: {},
    label: {},
});
